import { gql } from "@apollo/client";

const SAVE_CONCLUSION_PRESENCIAL = gql`
    mutation saveVisitaConclusionPresencial($input: AddVisitaConclusionPresencialInput!){
        saveVisitaConclusionPresencial(input: $input) {
            idVisita
        }
    }
`;

export default SAVE_CONCLUSION_PRESENCIAL;

export const adaptAddVisitaConclusionPresencialInput = (data) => ({
  idVisita: data.idVisita,
  evolucion: data.evolucion,
  capacitacion: !!data.capacitacion,
  fechaFin: data.fechaFin,
  justificacionHoras: data.justificacion,
  conformidad: !!data.conformidad,
  obsConformidad: data.obsConformidad
});